import axios from '../../../config-axios'
import { ElMessage } from 'element-plus'

export default {
    namespaced: true,
    state: () => ({
        companyListByCompanyPage: [],
        userListByCompanyPage: [],
    }),
    getters: {
        getCompanyListByCompanyPage(state) {
            return state.companyListByCompanyPage
        },
        getUserListByCompanyPage(state) {
            return state.userListByCompanyPage
        },
    },
    mutations: {
        setCompanyListByCompanyPage(state, options) {
            state.companyListByCompanyPage = options
        },
        setAddCompanyByCompanyPage(state, options) {
            const oldCompanyList = state.companyListByCompanyPage
            state.companyListByCompanyPage = [ ...oldCompanyList, options]
        },
        setChangeCompanyByCompanyPage(state, options) {
            let indexCompany = null
            state.companyListByCompanyPage.find((el, index) => {
                if (el.id == options.id) {
                    indexCompany = index
                }
            })
            if (indexCompany != null) {
                state.companyListByCompanyPage[indexCompany] = options
            }
        },
        setUserListByCompanyPage(state, options) {
            state.userListByCompanyPage = options
        },
        setAddNewUserByCompanyPage(state, options) {
            const oldList = state.userListByCompanyPage
            state.userListByCompanyPage = [...oldList, options]
            let indexComp = null
            state.companyListByCompanyPage.find((el, index) => {
                if (el.id == options.company_id) {
                indexComp = index
                }
            })
            if (indexComp != null) {
                state.companyListByCompanyPage[indexComp].count_users = state.companyListByCompanyPage[indexComp].count_users + 1
            }
        },
        setDeleteUser(state, options) {
            let userIndex = null;
            let companyIndex = null;
            state.userListByCompanyPage.find((el, index)=> {
                if (el.id == options) {
                userIndex = index;
                }
            })
            if (userIndex != null) {
                state.companyListByCompanyPage.find((el, index) => {
                    if (el.id == state.userListByCompanyPage[userIndex].company_id) {
                        companyIndex = index;
                    }
                })
                state.userListByCompanyPage.splice(userIndex, 1);
                if (companyIndex != null) {
                    state.companyListByCompanyPage[companyIndex].count_users = state.companyListByCompanyPage[companyIndex].count_users - 1;
                }
            }
        },
    },
    actions: {
        async getApiCompanyListByCompanyPage(context) {
            await axios.get('user/company/').then(response => {
                context.commit('setCompanyListByCompanyPage', response.data)
            }).catch(()=> {
                ElMessage.error('Ошибка, не удалось получить список компаний')
            })
        },
        async getApiAddCompanyByComanyPage(context, options) {
            await axios.post('user/company/', options).then(response => {
                context.commit('setAddCompanyByCompanyPage', response.data)
                ElMessage.success('Компания добавлена')
            }).catch(()=> {
                ElMessage.error('Ошибка, не удалось добавить компанию')
            })
        },
        async putApiCompanyByCompanyPage(context, options) {
            await axios.put('user/company/'+options.id+'/', options).then(response=>{
                context.commit('setChangeCompanyByCompanyPage', response.data)
                ElMessage.success('Компания изменина')
            }).catch(()=>{
                ElMessage.error('Ошибка, не удалось изменить компанию')
            })
        },
        async getApiUserListByCompanyPage(context, options) {
            await axios.get('user/'+options+'/').then(response=>{
                context.commit('setUserListByCompanyPage', response.data)
            }).catch(()=>{
                ElMessage.error('Ошибка, не удалось загрузить список пользователей')
            })
        },
        async postApiAddNewUser(context, options) {
            await axios.post('user/', options).then(response=>{
                context.commit('setAddNewUserByCompanyPage', response.data)
                ElMessage.success('Пользователь добавлен')
            }).catch(()=>{
                ElMessage.error('Ошибка, не удалось добавить пользователя')
            })
        },
        async deleteApiUser(context, options) {
            await axios.delete('user/'+options+'/').then(response=>{
                if (response.data.status) {
                    context.commit('setDeleteUser', options)
                    ElMessage.success('Пользователь удалён')
                } else {
                    ElMessage.error('Ошибка, не удалось добавить пользователя')
                }
            })
        },
        async putApiUser(context, options) {
            await axios.put('user/'+options.id+'/', options).then(()=>{
                ElMessage.success('Пароль изменен')
            }).catch(()=>{
                ElMessage.error('Ошибка, не удалось изменить пароль')
            })
        },
    }
}